document
	.querySelectorAll<HTMLElement>('.block-post-grid--mobile-slider .container')
	.forEach((slider) => {
		new (window as Window).Swiper(slider, {
			slidesPerView: 1.1,
			spaceBetween: 16,
			pagination: {
				el: slider.querySelector('.block-post-grid__pagination'),
				clickable: true,
			},
			breakpoints: {
				[window.impBreakpoints?.md ?? 768]: {
					enabled: false,
				},
			},
		});
	});
